import { render, staticRenderFns } from "./CallReAssign.vue?vue&type=template&id=0b7f84e5"
import script from "./CallReAssign.vue?vue&type=script&lang=js"
export * from "./CallReAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports